import { FilterChip } from "plos/src/components/Chip";
import { PopoverSelect } from "plos/src/components/PopoverSelects";
import { ListBoxItem, Selection } from "react-aria-components";
import { useTranslation } from "react-i18next";
import styles from "../../FilterPopovers/filterPopover.module.css";
import { GameweekFilterProps } from "./types";

const GameweekFilter = ({
  prizeEvent,
  handlePrizeEventChange,
  finishedEvents,
}: GameweekFilterProps) => {
  const { t } = useTranslation("prizes");
  const handleFilterChange = (keys: Selection) => {
    const key = Array.from(keys)[0];
    if (key == null) return;
    const gameweekId = Number(key);
    handlePrizeEventChange(gameweekId);
  };

  const selectedEvent = finishedEvents.find((event) => event.id === prizeEvent);
  const selectedEventId = selectedEvent && selectedEvent.id;

  const chipLabel = selectedEvent
    ? selectedEvent.name
    : finishedEvents[finishedEvents.length - 1].name;

  return (
    <PopoverSelect
      popoverTrigger={
        <FilterChip
          label={t("label.filterByGameweek", "Filter by gameweek")}
          selectedOption={[
            { label: chipLabel, value: String(selectedEventId) },
          ]}
        />
      }
      selectedKey={selectedEventId}
      handleOnChange={handleFilterChange}
    >
      {finishedEvents.map(({ name, id }) => (
        <ListBoxItem
          key={id}
          id={id}
          data-selected={id === prizeEvent}
          className={styles.popoverListItem}
          textValue={name}
        >
          {name}
        </ListBoxItem>
      ))}
    </PopoverSelect>
  );
};

export default GameweekFilter;
